import React, { useEffect } from 'react';
import './Tarif.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Tarif = ({ title, subtitle, image, description }) => {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  const handleMouseEnter = (e) => {
    e.target.classList.add('transition');
  };

  return (
    <div className="custom-card" data-aos-offset="200" data-aos="flip-right" onMouseEnter={handleMouseEnter}>

      <div className="custom-card-img">
        <img src={"/img/tarifs/" + image} alt={image.split('.')[0]} />
      </div>

      <div className="custom-card-body">
        <div className="custom-card-prestation">{title}</div>
        <div>
        <h3 className="custom-card-title">{subtitle}</h3>
        
          <p className="custom-card-text">{description}</p>
          <a href="#contact">
            <button className="custom-card-button">Contactez-moi</button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Tarif;